import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
import { workReportStatusMeta } from '../workReportUtils';
export default {
  __name: 'ReportStatusBadge',
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const currentStatus = computed(() => workReportStatusMeta(props.status));
    const label = computed(() => currentStatus.value.label);
    const colorClass = computed(() => currentStatus.value.color);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["status-badge", colorClass.value])
      }, _toDisplayString(label.value), 3);
    };
  }
};